function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
import copy from '../../assets/copy-button.svg?type=raw';
import sheet from './ctc-button.css?polyfill=type-css' ;

const template = document.createElement('template');
template.innerHTML = `
  <button id="icon" title="Copy to clipboard">${copy}</button>
`;
export default class CopyToClipboardButton extends HTMLElement {
  constructor() {
    super();
    this.root = null;
  }
  connectedCallback() {
    if (!this.shadowRoot && typeof window !== 'undefined') {
      this.root = this.attachShadow({
        mode: 'open'
      });
      if (this.root) {
        this.root.appendChild(template.content.cloneNode(true));
        this.root.adoptedStyleSheets = [sheet];
        _optionalChain([this, 'access', _ => _.root, 'access', _2 => _2.getElementById, 'call', _3 => _3('icon'), 'optionalAccess', _4 => _4.addEventListener, 'call', _5 => _5('click', () => {
          const contents = this.getAttribute('content');
          if (!contents) {
            console.warn('No content provided to copy to clipboard');
            return;
          }
          navigator.clipboard.writeText(contents);
          console.log('copying the following contents to your clipboard =>', contents);
        })]);
      }
    }
  }
}
customElements.define('wcc-ctc-button', CopyToClipboardButton);
